module.exports = __webpack_public_path__ + "img/fastcharger-realized-semipublic.4dd1525d.png";